export default {
    check_questions: [],
    check_question: null,
}
